<h2>VIN</h2>
<hr>
<div class="img-popup-vin"><img src="/assets/images/image-37.png"></div>
<hr>
<mat-dialog-actions align="end">
    <button mat-button mat-stroked-button mat-dialog-close>Cerrar</button>
  </mat-dialog-actions>